import routerOptions0 from "/home/tickets-hzbmt/tickets.muzieum.nl/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}